export const SUGGESTED_AMOUNTS: number[] = [30, 60, 90, 120];
